module.exports = __webpack_public_path__ + "img/apply-poster.e21334fa.jpg";